import {inject, Injectable, NgZone} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {share} from 'rxjs/operators';
import {IPC, IPC_APP_START_WATCHER} from '../../../constants/shared.constants';
import {ElectronService} from '../electron.service';
import {FileWatcherEventTypeEnum} from '../../../enums/file-watcher-event-type.enum';
import {FileWatcherEvent} from '../../../models/file-watcher-event.model';
import {FileWatcherFile} from '../../../models/file-watcher-file.model';

@Injectable({
    providedIn: 'root'
})
export class FileWatcherService {
    public subscribableFileWatcherEvents$: Observable<FileWatcherEvent>;
    private readonly fileWatcherEvents$ = new Subject<FileWatcherEvent>();
    private readonly ngZone = inject(NgZone);

    public constructor() {
        this.subscribableFileWatcherEvents$ = this.fileWatcherEvents$.pipe(share());
    }

    public watch(): void {
        if (!ElectronService.isElectronApp()) {
            console.error('Cant find electron app!');
            return;
        }
        console.log('Start file watcher');
        ElectronService.ipcRender?.send(IPC_APP_START_WATCHER);
        ElectronService.ipcRender?.receive<Array<FileWatcherFile>>(IPC.WATCHER.FILE_CREATED_MULTI, fileWatcherFiles => {
            const filteredFileWatcherFiles = fileWatcherFiles
                .filter(file => !file.fileName.includes('~'))
                .map(file => file.filePath);
            for (const file of filteredFileWatcherFiles) {
                this.emitFileWatcherEvent(FileWatcherEventTypeEnum.Add, file);
            }
            this.emitFileWatcherEvent(FileWatcherEventTypeEnum.AddDone, '');
        });
        ElectronService.ipcRender?.receive<FileWatcherFile>(IPC.WATCHER.FILE_CREATED, fileWatcherFile => {
            if (fileWatcherFile.fileName.includes('~')) {
                return;
            }
            this.emitFileWatcherEvent(FileWatcherEventTypeEnum.Add, fileWatcherFile.filePath);
            this.emitFileWatcherEvent(FileWatcherEventTypeEnum.AddDone, '');
        });
        ElectronService.ipcRender?.receive<FileWatcherFile>(IPC.WATCHER.FILE_CHANGE, fileWatcherFile => {
            if (fileWatcherFile.fileName.includes('~')) {
                return;
            }
            this.emitFileWatcherEvent(FileWatcherEventTypeEnum.Change, fileWatcherFile.filePath);
        });
        ElectronService.ipcRender?.receive<FileWatcherFile>(IPC.WATCHER.FILE_REMOVED, fileWatcherFile => {
            if (fileWatcherFile.fileName.includes('~')) {
                return;
            }
            this.emitFileWatcherEvent(FileWatcherEventTypeEnum.Delete, fileWatcherFile.filePath);
        });
    }

    public emitImportDoneEvent(): void {
        ElectronService.ipcRender?.send(IPC.WATCHER.NORMAL_FILES_IMPORT_DONE);
    }

    private emitFileWatcherEvent(type: FileWatcherEventTypeEnum, filePath: string): void {
        this.ngZone.run(() => {
            this.fileWatcherEvents$.next({
                type,
                filePath
            });
        });
    }

}
